import {
  CAMPAIGN_METRICS,
  REP_STACK_METRICS,
  REP_TREND_METRICS,
} from '../componentKeys.js'

const identifiers = {
  key: 'transfersPerBillableHour',
  type: 'call',
  access: 'stats',
}

const formatting = {
  format: {
    title: 'Transfers / Billable Hour',
  },
}

const keys = {
  componentKeys: [CAMPAIGN_METRICS, REP_STACK_METRICS, REP_TREND_METRICS],
  healthKey: 'metric_health',
}

const calculation = {
  calcType: 'divide',
  dividend: { stat: 'transfer_complete' },
  divisor: { stat: 'billable_hours', convertTo: 'hours' },
}

const transfersPerBillableHour = {
  metaData: Object.assign(identifiers, formatting, keys, calculation),
  calculationConfig: calculation,
}

export { transfersPerBillableHour }
